import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasketWithPrice, BookBasketOffer, SelectBasketOffer } from 'app/shared/models/class/basket/basketList';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasket, SessionBasketBookable, SessionBasketOfferDuplicate, SessionBasketTraineeQuantity } from 'app/shared/models/class/session-basket/session-basket';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SessionBasketService {

  constructor(
    private http: HttpClient,
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getBasketList(userKey: number): Observable<FullOffer[]> {
    return this.http.get<FullOffer[]>(`${environment.apiUrl}/SessionBasket/${userKey}`);
  }

  getPriceSession(userKey: number): Observable<BasketWithPrice> {
    return this.http.get<BasketWithPrice>(`${environment.apiUrl}/SessionBasket/Pricing/${userKey}`);
  }

  checkSessionBasketBookable(userKey: number): Observable<SessionBasketBookable[]> {
    return this.http.get<SessionBasketBookable[]>(`${environment.apiUrl}/SessionBasket/checkSessionBasketBookable/${userKey}`);
  }

  getImageClub(userKey: number): Observable<string> {
    return this.http.get<string>(`${environment.apiUrl}/SessionBasket/SessionBasketClubLogo/${userKey}`);
  }

  applyPromoCodeToSessionBasket(userKey: number, promoCodeName: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/SessionBasket/Pricing/PromoCode/${userKey}/${promoCodeName}`);
  }


  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  addInMyBasket(userKey: number, offerKey: number) {
    return this.http.post(`${environment.apiUrl}/SessionBasket/AddToSessionBasket/${userKey}/${offerKey}`, null);
  }

  canAddToSessionBasket(userKey: number, offerKey: number) {
    return this.http.post(`${environment.apiUrl}/SessionBasket/CanAddToSessionBasket/${userKey}/${offerKey}`, null);
  }

  bookOffer(myOrder: BookBasketOffer) {

    return this.http.post<number>(`${environment.apiUrl}/SessionBasket/BookSessionBasket`, myOrder);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  UpdateSession(sessionBasket: SessionBasket) {
    return this.http.put(`${environment.apiUrl}/SessionBasket/UpdateSession`, sessionBasket);
  }

  UpdateQuantityBasketOffer(sessionBasketTraineeQuantity: SessionBasketTraineeQuantity) {
    return this.http.put(`${environment.apiUrl}/SessionBasket/UpdateTraineeQuantity`, sessionBasketTraineeQuantity);
  }

  UpdateSessionBasketTrainees(sessionBasketKey: number, traineeKeys: string) {

    const formData = new FormData();
    formData.append('sessionBasketKey', sessionBasketKey.toString());
    formData.append('traineeKeys', traineeKeys);

    return this.http.put(`${environment.apiUrl}/SessionBasket/UpdateSessionBasketTrainees`, formData);
  }

  duplicateSessionBasketOffer(session: SessionBasketOfferDuplicate) {
    const formData = new FormData();
    formData.append('sessionBasketOfferString', JSON.stringify(session));

    return this.http.put(`${environment.apiUrl}/SessionBasket/DuplicateSessionBasketOffer`, formData);
  }

  selectBasketOffer(selection: SelectBasketOffer) {
    const formData = new FormData();
    formData.append('selectSessionBasketOfferString', JSON.stringify(selection));

    return this.http.put(`${environment.apiUrl}/SessionBasket/SelectSessionBasketOffer`, formData);
  }

  checkSessionBasketComplete(selection: SelectBasketOffer) {
    const formData = new FormData();
    formData.append('selectSessionBasketOfferString', JSON.stringify(selection));

    return this.http.put(`${environment.apiUrl}/SessionBasket/CheckSessionBasketComplete`, formData);
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELTETE                                  */
  /* -------------------------------------------------------------------------- */

  deleteSessionBasketInMyBasket(userKey: number, sessionBasketKey: number) {
    return this.http.delete(`${environment.apiUrl}/SessionBasket/DeleteFromSessionBasket/${userKey}/${sessionBasketKey}`);
  }
}
